import { ProjectModel } from '@bryntum/schedulerpro/schedulerpro.module.js';
import { MAX_CALENDAR_RANGE } from '../../../../scheduler/schedulerConstants';
import { ScheduleCalculatorBusyError } from './errors';

// Single shared project instance (lightweight, no UI overhead)
let sharedProject: ProjectModel | null = null;
let isBusy = false;

export const createSchedulerProject = () =>
    new ProjectModel({
        maxCalendarRange: MAX_CALENDAR_RANGE,
        adjustDurationToDST: true
    });

/**
 * Releases the scheduler instance and clears all stores for next use.
 */
function releaseSchedulerProjectInstance(): void {
    // Clear all stores to ensure clean state for next use
    if (sharedProject) {
        sharedProject.eventStore.removeAll();
        sharedProject.resourceStore.removeAll();
        sharedProject.assignmentStore.removeAll();
        sharedProject.dependencyStore.removeAll();
        sharedProject.calendarManagerStore.removeAll();
    }

    isBusy = false;
}

/**
 * Acquires the shared project instance for schedule calculations.
 * Creates a new instance on first use and reuses it for subsequent calls.
 *
 * @returns Object containing the project and a release function
 * @throws ScheduleCalculatorBusyError if a calculation is already in progress
 */
export function acquireSchedulerProjectInstance(): {
    project: ProjectModel;
    releaseSchedulerProjectInstance: () => void;
} {
    if (isBusy) {
        throw new ScheduleCalculatorBusyError();
    }

    isBusy = true;

    if (!sharedProject) {
        sharedProject = createSchedulerProject();
    }

    return {
        project: sharedProject,
        releaseSchedulerProjectInstance
    };
}
